import { Render } from './utils'

export const Routes = [
    {
        url: '/no-encontrado',
        template: 'not-found',
        render: Render
    },
    {
        url: '/mis-notificaciones',
        template: 'my-notifications',
        render: Render
    },
    {
        url: '/notificacion/:id',
        template: 'notification',
        render: Render
    },
    {
        url: '/mapa',
        template: 'map',
        render: Render
    },
    {
        url: '/centros-de-atencion',
        template: 'customer-service-centers',
        render: Render
    },
    {
        url: '/historial',
        template: 'history',
        render: Render
    },
    {
        url: '/visita/:id',
        template: 'visit',
        render: Render
    },
    {
        url: '/cambiar-password',
        template: 'change-password',
        render: Render
    },
    {
        url: '/finalizar-sesion',
        template: 'logout',
        render: Render
    },
    {
        url: '/cerrar-sesion',
        template: 'logout',
        render: Render
    },
    {
        url: '/',
        template: 'my-notifications',
        render: Render
    }
]
